import React from "react";

import { Box, DialogTitle, IconButton, Typography } from "@material-ui/core";
import { Close } from "@material-ui/icons";

type Props = {
  title?: string;
  subtitle?: string;
  onClose: () => void;
};

export default function Title({ title, subtitle, onClose }: Props) {
  return (
    <DialogTitle disableTypography>
      <Box alignItems="center" display="flex">
        <Box flexGrow={1}>
          <Typography component="h3" variant="h2">
            {title}
          </Typography>
          {subtitle && <Typography variant="subtitle2">{subtitle}</Typography>}
        </Box>
        <Box margin={-1}>
          <IconButton size="small" onClick={onClose}>
            <Close />
          </IconButton>
        </Box>
      </Box>
    </DialogTitle>
  );
}
